function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8902 12.5105C24.8902 19.0827 19.5624 24.4105 12.9902 24.4105C6.41805 24.4105 1.09023 19.0827 1.09023 12.5105C1.09023 5.93831 6.41805 0.610498 12.9902 0.610498C19.5624 0.610498 24.8902 5.93831 24.8902 12.5105Z",
  stroke: "#CED2E3",
  strokeWidth: 1.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1034 8.91857C13.7802 8.91857 14.2554 8.42897 14.2554 7.79537C14.2554 7.20496 13.7658 6.75857 13.1034 6.75857C12.441 6.75857 11.9514 7.23377 11.9514 7.83857C11.9514 8.44337 12.441 8.91857 13.1034 8.91857ZM12.1962 17.8754H13.9962V10.1858H12.1962V17.8754Z",
  fill: "#CED2E3"
});

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.25b30f8e.svg";
export { ForwardRef as ReactComponent };